module.exports = __webpack_public_path__ + "static/img/phone.2d928dd6.png";